var $5768444fcb73d3f4$exports = {};
$5768444fcb73d3f4$exports = {
    "clear": `\u{5E0}\u{5E7}\u{5D9}`,
    "invalid": `(\u{5DC}\u{5D0} \u{5D7}\u{5D5}\u{5E7}\u{5D9})`,
    "loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "noResults": `\u{5D0}\u{5D9}\u{5DF} \u{5EA}\u{5D5}\u{5E6}\u{5D0}\u{5D5}\u{5EA}`,
    "valid": `(\u{5EA}\u{5B8}\u{5E7}\u{5B5}\u{5E3})`
};


export {$5768444fcb73d3f4$exports as default};
//# sourceMappingURL=he-IL.module.js.map
